import { AdvancedMarker } from '@vis.gl/react-google-maps';
import React from 'react';


interface CompanyAdvanceMarkerProps {
    index: number | string;
    label: string;
    coordinates: { lat: number; lng: number };
}

const CompanyAdvanceMarker: React.FC<CompanyAdvanceMarkerProps> = ({ index, label, coordinates }) => {
    return (
        <AdvancedMarker
            key={index}
            position={{ lat: coordinates.lat, lng: coordinates.lng }}
            ref={(marker) => {
                if (marker) {
                    const content = document.createElement('div');
                    content.style.display = 'flex';
                    content.style.flexDirection = 'column';
                    content.style.alignItems = 'center';

                    // Add company name above the marker
                    const textContent = document.createElement('div');
                    textContent.style.color = 'white';
                    textContent.style.fontSize = '12px';
                    textContent.style.fontWeight = 'bold';
                    textContent.style.background = '#000';
                    textContent.style.padding = '3px 6px';
                    textContent.style.borderRadius = '6px';
                    textContent.style.boxShadow = '0 2px 6px rgba(0,0,0,0.4)';
                    textContent.style.marginBottom = '3px';
                    textContent.textContent = label || '';

                    // Add marker icon
                    const markerIcon = document.createElement('div');
                    markerIcon.style.position = 'relative';
                    markerIcon.style.width = '10px';
                    markerIcon.style.height = '10px';
                    markerIcon.style.background = '#FF4500';
                    markerIcon.style.borderRadius = '50%';
                    markerIcon.style.boxShadow = '0 2px 6px rgba(0,0,0,0.4)';
                    markerIcon.style.border = '2px solid black';


                    content.appendChild(textContent);
                    content.appendChild(markerIcon);
                    marker.content = content;
                }
            }}
        />
    );
};

export default CompanyAdvanceMarker;